import { Container, Paper, Text } from "@mantine/core";
import React from "react";

const Reviews = () => {
  return (
    <Container className="my-20">
      <Text className="text-center text-xl text-[#737373] border-b-yellow-500 border-b-2 w-[200px] mx-auto">
        CUSTOMER REVIEWS
      </Text>
      <Paper className="flex justify-center items-center flex-col gap-5 my-10">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FRectangle%2052.png?alt=media&token=4e7840ca-2047-45d7-82e3-950b0fa1b964"
          className="w-20 h-20 object-cover rounded-full"
          alt=""
        />
        <p className="text-xl text-gray-500">John Doe</p>
        <p className="w-full md:w-1/2 text-[#867985] tracking-widest leading-8">
          "I recently visited this fashion shop and I was blown away by the
          amazing selection of clothing and accessories they had. The store was
          well-organized and the staff were incredibly helpful and friendly “
        </p>
        <div className="flex gap-1">
          <div className="w-2 h-2 bg-gray-500 rounded-full"></div>
          <div className="w-2 h-2 bg-gray-100 rounded-full"></div>
          <div className="w-2 h-2 bg-gray-100 rounded-full"></div>
        </div>
      </Paper>
    </Container>
  );
};

export default Reviews;
